
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Language, LanguageContextType, TranslationKey } from '@/types/translations';
import { getTranslations } from '@/translations';

const LanguageContext = React.createContext<LanguageContextType | undefined>(undefined);

export { LanguageContext }; // Export the context

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  // Determinar idioma basado en la URL
  const isEnglishRoute = location.pathname.startsWith('/en');
  const language: Language = isEnglishRoute ? 'en' : 'es';

  const setLanguage = React.useCallback((newLang: Language) => {
    // Esta función ahora no hace nada directamente, 
    // el cambio de idioma se maneja a través de navegación
    console.log('Language change requested:', newLang);
  }, []);

  // Obtener traducciones de forma síncrona
  const translations = React.useMemo(() => {
    return getTranslations(language);
  }, [language]);

  const t = React.useCallback((key: TranslationKey): string => {
    return translations[key] || key;
  }, [translations]);

  const contextValue = React.useMemo(() => ({
    language,
    setLanguage,
    t
  }), [language, setLanguage, t]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = React.useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
